export const FIELD_TYPES = {
  ABSENCES: 'absences',
  ADD_COURSES: 'addCourses',
  ADD_ADDITIONAL_ROLES_FIELD: 'addAdditionalRolesField',
  ADD_IMAGE: 'addImage',
  ADD_USERS_TABLE: 'addUsersTable',
  CREATABLE_TAGS: 'creatableTexts',
  CREATABLE_TEXTS: 'creatableTags',
  COLLAPSABLE_FILTERS: 'collapsableFilters',
  CYCLE_STEPS: 'cycleSteps',
  CYCLE_STEP_ASSIGNMENTS: 'cycleStepAssignments',
  TEXT: 'text',
  SELECT: 'select',
  AUTOCOMPLETE: 'autocomplete',
  SELECT_WITH_RANGE: 'selectWithRange',
  RANGE_FROM: 'range_from',
  RANGE_TO: 'range_to',
  RADIO_GROUP: 'radio_group',
  HAS_ANSWER_COMMENT: 'has_answer_comment',
  BUTTON_SWITCH: 'toggleButtonSwitch',
  COLOR_PICKER: 'color_picker',
  CREATED_BY: 'created_by',
  ATTRIBUTES_QUESTIONS_FORM: 'add_attribute_questions',
  SEARCH: 'search',
  SETTINGS_SUMMARY: 'settings',
  SWITCH: 'switch',
  TOGGLEABLE_SETTINGS: 'toggleableSettings',
  CHECKBOX: 'checkbox',
  CHECKBOX_GROUP: 'checkboxGroup',
  DATE_PICKER: 'date',
  MULTIPLE_DATE_PICKER: 'multipleDate',
  RICH_TEXT_EDITOR: 'richTextEditor',
  SUBTITLE: 'subtitle',
  SUBTITLE_WITH_TOOLTIP: 'subtitle_with_tooltip',
  TIME_PICKER: 'time',
  SURVEY_PREVIEW: 'surveyPreview',
  READ_ONLY: 'readOnly',
  PREVIEW: 'preview',
  A4_DOCUMENT_PREVIEW: 'a4DocumentPreview',
  PEOPLE_PICKER: 'peoplePicker',
  PEOPLE_INFO: 'peopleInfo',
  USER_AVATAR: 'userAvatar',
  MANAGE_USERS_LIST: 'manageUsersList',
  MEETING_AGENDA: 'meetingAgenda',
  MEETING_IMPRESSION: 'meetingImpression',
  MEETING_STATUS: 'meetingStatus',
  NUMBER_STEPPER: 'numberStepper',
  FILTERS_SETUP: 'filtersSetup',
  TASKS: 'tasks',
  SLIDER: 'slider',
  SELECTABLE_LIST: 'selectableList',
  PASSWORD: 'password',
  REVIEWS: 'reviews',
  UPLOAD_FILE: 'uploadFile',
  DATE_RANGE_WITH_TEXT_LIST: 'date_range_with_text_list',
  SALARY_RANGE: 'salary_range',
  TEXT_LIST: 'text_list',
  DOCUMENT_TYPE_FIELDS: 'document_type_fields',
  VOTE: 'vote',
  RECRUITMENT_STEPS: 'recruitmentSteps',
  QUESTIONNAIRE_QUESTIONS: 'questionnaireQuestions',
};
